// @ts-check
import React, { useState, useEffect } from 'react'
import cn from 'classnames'
import { usePrevious } from '../../../components/utils/hooks'
import styles from './style.css'

/**
 * @param {{
 * children: React.ReactChild[]
 * isCurrent: boolean
 * index: number
 * }} props
 */
const Step = ({
  children,
  isCurrent,
  index
}) => {
  const prevIsCurrent = usePrevious(isCurrent)
  const [visibilityClass, setVisibilityClass] = useState('')

  useEffect(() => {
    if (isCurrent === true && prevIsCurrent !== isCurrent) {
      setVisibilityClass('visibleAnimation')
    } else {
      setVisibilityClass('')
    }
  }, [isCurrent, index])

  return (
    <div className={cn(styles.step, styles[visibilityClass], { [styles.hidden]: !isCurrent })}>
      <div>{children}</div>
    </div>
  )
}

export { Step }
